// extracted by css-extract-rspack-plugin
export default {"container":"_7cc53aff","imageContainer":"_b2f66018","textContainer":"_da2f542","link":"_ba879f38","linkText":"_c8be9105"};